import { useEffect, useState } from 'react';
import { makeStyles, Tooltip } from '@material-ui/core';
import UtilService from '../../../../../../helper/service';
import { useDispatch, useSelector } from 'react-redux';
import { addOverviewToAnalysisKeyMoment, getAllAnalysisPills } from '../../../../../../store/actions/creator/analysis';
import { apiClient } from '../../../../../../config/apiClient';
import _ from 'underscore';
import clsx from 'clsx';
import AnalyzeKeyMomentPopOut from '../../../../../atoms/creator/analyzeKeyMomentPopout';
import { useStylesTooltip } from "../../../../../../config/theme";

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    marginBottom: 20,
    height: 74,
    zIndex: 4,
  },
  pillInTime: {
    width: '18px!important',
    height: '18px!important',
    borderRadius: '9px!important',
    margin: -3,
    transition: '0.2s',
  },
  pills: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: 0,
    zIndex: 4,
  },
  boxInTime: {
    height: '50px!important',
    marginTop: -4,
    transition: '0.4s',
    marginBottom: 2,
  },
  box: {
    position: 'absolute',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: '#fff',
    fontFamily: 'roboto-bold',
    fontSize: 18,
    borderRadius: 8,
    height: 45,
    zIndex: 4,
    '&:hover': {
      cursor: 'pointer',
      height: 52,
      marginTop: -3,
      transition: '0.4s',
      marginBottom: -4,
    },
    marginRight: 2,
  },
  section: {
    display: 'flex',
    flexDirection: 'row',
    height: 16,
    marginBottom: 3,
  },
  pill: {
    position: 'absolute',
    width: 14,
    height: 14,
    borderRadius: 7,
    background: 'grey',
    '&:hover': {
      width: 18,
      height: 18,
      borderRadius: 9,
      margin: -3,
      transition: '0.2s',
      cursor: 'pointer',
    },
  },
}));

function PillSection(props: any) {

  const classes = useStyles();
  const tooltipClasses = useStylesTooltip();
  const dispatch = useDispatch();

  const { graphWidth, graphData, clip, videoPlayed, onZoom, popOut, marginTop } = props;
  const { analyseStart, analyseEnd, cliped, currentSession, excludedParticipants, all, identifiers, tags, stimulus, overviewToKeymoment, settings, hiddenParticipants } = useSelector((state: any) => state.analysis);
  const { session_code, session_type, session_trim_from, session_trim_to, started_at, ended_at, scheduled_end_at, session_length } = currentSession;
  const { graphZoom, videoPopIn, videoRemoved } = settings;
  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : "";
  const tenant_id = loginUserData.customer_id;

  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const [overlay, setOverlay] = useState<any>(null);

  const start = cliped ? cliped.start_clip - analyseStart : 0
  const graphStart = cliped ? cliped.start_clip : analyseStart;
  const analysed_end = Math.floor(ended_at ? ended_at : scheduled_end_at);
  const refactorStart = (session_type === 'MODERATED') ? graphStart : 0;

  const { pills, activeParticipant, immersion } = graphData
  const videoAvailable = (!cliped || cliped && (cliped.start_clip - analyseStart < stimulus?.stimulus_video_length)) && !videoRemoved
  const [refactorPills, setRefactorPills] = useState<any>([]);
  const startPoint = _.first(immersion?.data);
  const finalPoint = _.last(immersion?.data);

  const availableStart = UtilService.getLocalEpoch2(startPoint?.time_stamp || "1970-01-01 00:00:00");
  const availableEnd = UtilService.getLocalEpoch2(finalPoint?.time_stamp || "1970-01-01 00:00:00");
  const limitSeconds = 60;
  const isBlankRule = Number(session_length) <= limitSeconds;

  const immersionData = immersion.data.reduce(function (filtered: any, item: any) {
    filtered.push({
      immersion_index: item.immersion_index,
      time_stamp: UtilService.getLocalEpoch2(item.time_stamp)
    })
    return filtered
  }, [])

  useEffect(() => {
    if (activeParticipant === 'All' && pills.length === 0 && (analyseEnd - analyseStart) > 60 && !cliped && (all && all[0]?.activeParticipant === 'All')) {
      const AsyncRequest = {
        tenant_id,
        session_code,
        stimulus_id: stimulus?.stimulus_id,
        session_started_at: analyseStart,
        session_completed_at: analyseEnd,
        identifiers,
        from_clip: UtilService.calcVideoEnd(0),
        to_clip: UtilService.calcVideoEnd(stimulus?.stimulus_video_length)
      };

      const ModRequest = {
        identifiers,
        from_epoch: analyseStart,
        to_epoch: analyseEnd,
        session_started_at: analyseStart,
        session_completed_at: analyseEnd,
        tenant_id: Number(loginUserData.customer_id),
        session_code,
      };

      dispatch(getAllAnalysisPills((session_type === 'MODERATED') ? ModRequest : AsyncRequest, tenant_id, session_code, session_type === 'MODERATED'))
    }
  }, [])

  useEffect(() => {
    if (overviewToKeymoment) {
      const hasKey = overviewToKeymoment?.epoch_start
        ? document.getElementById("key_" + overviewToKeymoment?.epoch_start)
        : document.getElementById("segment_" + overviewToKeymoment?.start_marker_at)

      if (hasKey) {
        hasKey.click();

        if (session_type === 'ASYNC') {
          popOut && popOut(overviewToKeymoment?.start ? overviewToKeymoment.start : overviewToKeymoment?.epoch_start);
        }

        if (session_type === 'MODERATED' && stimulus) {
          popOut && popOut(overviewToKeymoment?.start ? (overviewToKeymoment.start - graphStart + start) : (overviewToKeymoment?.epoch_start - graphStart + start));
        }

        dispatch(addOverviewToAnalysisKeyMoment(null))
      }
    }
  }, [overviewToKeymoment, refactorPills])


  const handlePillClick = async (event: any, data: any, type: string) => {
    setOverlay(null);

    const param = { ...data }
    const isPill = data?.start === 0 || data?.start !== undefined;
    const segment_start = (isPill ? data.start : data?.epoch_start) - (session_type === 'ASYNC' ? 0 : graphStart);
    const segment_end = (data?.end ? data.end : data?.epoch_end) - (session_type === 'ASYNC' ? 0 : graphStart);

    if (session_type === 'ASYNC') {
      const pillTime = isPill ? data.start : data?.epoch_start;
      popOut && popOut((cliped && pillTime < graphStart) ? graphStart : pillTime);
    }

    if (session_type === 'MODERATED') {
      const pillTime = isPill ? (data.start - graphStart + start) : (data?.epoch_start - graphStart + start);
      popOut && popOut(cliped && pillTime < start ? start : pillTime);
    }

    param['color'] = data?.pill ? data.pill : data?.color_indicator;
    param['type'] = type;
    param['segment_start'] = UtilService.getTimeLabel(segment_start, 1, session_type === 'ASYNC' ? 0 : start);
    param['segment_end'] = UtilService.getTimeLabel(segment_end, 1, session_type === 'ASYNC' ? 0 : start);
    param['segment_length'] = UtilService.getTimeLabel(segment_end - segment_start, 1, 0);
    param['length'] = segment_end - segment_start;
    param['start'] = (data?.start !== undefined) ? data.start : data?.epoch_start;
    param['end'] = data?.end ? data.end : data?.epoch_end;

    const tag = tags.find((item: any) => item['tagName'] === activeParticipant);

    const requestMod = {
      identifiers: (activeParticipant === 'All') ? _.difference(identifiers, excludedParticipants) : tag ? tag.identifiers : [activeParticipant],
      from_epoch: isPill ? data.start : data?.epoch_start,
      to_epoch: data?.end ? data.end : data?.epoch_end,
      session_started_at: session_trim_from ? Number(started_at) : analyseStart,
      session_completed_at: session_trim_to ? analysed_end : analyseEnd,
      tenant_id: Number(loginUserData.customer_id),
      session_code,
    };

    const requestAsync = {
      tenant_id: loginUserData.customer_id,
      session_code,
      stimulus_id: stimulus?.stimulus_id,
      session_started_at: analyseStart,
      session_completed_at: analyseEnd,
      identifiers: (activeParticipant === 'All') ? _.difference(identifiers, excludedParticipants) : tag ? tag.identifiers : [activeParticipant],
      from_clip: UtilService.calcVideoEnd((param['start'] !== undefined) ? param['start'] : 0),
      to_clip: UtilService.calcVideoEnd(data?.end ? data.end : data?.epoch_end)
    };

    setAnchorEl(event && event.currentTarget);

    try {
      const res = await apiClient(true).post(`/analysis/v2/${session_type === 'ASYNC' ? 'async' : 'sync'}/index/safety/${loginUserData.customer_id}/${session_code}`,
        session_type === 'ASYNC' ? { ...requestAsync } : { ...requestMod });
      if (res.data && res.data.safety_index > 1) {
        param['safety_color'] = res.data.color_indicator;
        param['safety_index'] = res.data.safety_index;
        param['safety_indicator'] = res.data.context_indicator;
      } else {
        param['safety_color'] = 'gray';
        param['safety_index'] = '--';
        param['safety_indicator'] = '';
      }
    } catch {
      param['safety_color'] = 'gray';
      param['safety_index'] = '--';
      param['safety_indicator'] = '';
    }

    setOverlay(param);
  };

  if (!pills) {
    return null
  }

  const newPills: any = [];

  if (pills && pills[0]?.moment && stimulus) {
    newPills.push({
      pill: "blank",
      start: 0,
      end: stimulus.stimulus_video_length,
      overall_index: '--',
      tier_indicator: "High",
      color_indicator: "gray",
      context_indicator: "",
      moments: pills
    });
  }

  useEffect(() => {
    onGetBlankPills();
  }, [hiddenParticipants, cliped, all.length, pills])

  const onGetBlankPills = async () => {
    const convertedPills = pills
      .filter((x: any) => x.pill === 'RED' || x.pill === 'GREEN')
      .map((u: any, k: number) => {
        if (pills.length === k + 1) {
          return { ...u, end: _.min([u.end, availableEnd]) }
        } else {
          return u
        }
      })

    const convertedData = isBlankRule ? convertedPills
      .reduce((prev: any[], c: any, index: number) => {
        const first = convertedPills[index - 1]?.end || (session_type === 'MODERATED' ? availableStart : 0);
        const second = convertedPills[index]?.start;
        const isAvailable = immersionData.find((x: any) => x.time_stamp >= first && x.time_stamp < second)
        if (first !== second && isAvailable) {
          prev.push({
            start: first,
            end: second,
            pill: 'BLANK',
          })
        }

        if (convertedPills.length === index + 1 && second !== (Number(session_length) + refactorStart) && convertedPills[index]?.end < _.min([availableEnd, Number(session_length) + refactorStart])) {
          prev.push({
            start: convertedPills[index]?.end,
            end: _.min([Number(session_length) + refactorStart, availableEnd + refactorStart, cliped ? cliped.end_clip : availableEnd]),
            pill: 'BLANK',
          })
        }
        prev.push(c)
        return prev
      }, []) : pills;

    if (isBlankRule && convertedPills.length === 0) {
      const fullGreypills = [{
        start: availableStart,
        end: availableEnd,
        pill: immersion.overall_index > 75 ? 'GREEN' : (immersion.overall_index < 35 ? 'RED' : 'BLANK'),
        overall_index: immersion.overall_index,
        context_indicator: 'INTERESTED'
      }]
      setRefactorPills(fullGreypills)
    } else {
      setRefactorPills(convertedData)
    }


    const bigData = await Promise.all(convertedData.map(async (item: any) => {
      const length = item.end - item.start;
      const sum = _.reduce(immersion?.data, function (memo: any, num: any, index: any) {
        if (index + availableStart >= item.start && index + availableStart < item.end + 1 && item.pill === 'BLANK') {
          return memo + num?.immersion_index;
        } else {
          return memo;
        }
      }, 0) / (length === 0 ? 1 : length + 1);
      if (item.overall_index) return item;
      return {
        ...item,
        // pill:  immersion.overall_index > 75 ? 'GREEN' : immersion.overall_index < 35 ? 'RED' : 'BLANK',
        pill: Math.floor(sum) > 75 ? 'GREEN' : (Math.floor(sum) < 35 ? 'RED' : 'BLANK'),
        overall_index: Math.floor(sum),
        context_indicator: 'INTERESTED'
      }
    }))

    if (isBlankRule && convertedPills.length === 0) {
    } else {
      setRefactorPills(bigData)
    }
  }


  return (
    <div
      className={classes.root}
      style={{
        marginTop: clip ? -85 : -131,
        width: graphWidth
      }}
    >
      <div
        className={classes.pills}
        style={{
          width: graphWidth,
          marginTop: marginTop ? marginTop : (stimulus ? 24 : 21),
          position: 'relative'
        }}
      >
        {
          (newPills.length === 1 ? newPills : refactorPills).map((item: any, index: number) => {

            let start = item.start ? item.start : item.epoch_start;
            let end = item.end ? item.end : item.epoch_end;
            start = (cliped && index === 0 && !isBlankRule) ? cliped.start_clip : start;
            end = (cliped && (index === refactorPills.length - 1) && !isBlankRule) ? cliped.end_clip : end;
            if (!start) {
              start = 0;
            }
            if (!end) {
              end = 0;
            }
            if (cliped && stimulus && start < cliped.start_clip) {
              start = cliped.start_clip
            }
            if (cliped && stimulus && end > cliped.end_clip) {
              end = cliped.end_clip
            }

            const getPosition = (c: any) => {
              return (c.epoch_start - (session_type === 'ASYNC' ? cliped ? cliped.start_clip : 0 : graphStart)) * 15 / Math.pow(graphZoom, 2);
            }

            const isPillInArea = (c: any) => {
              const pillTime = (stimulus && videoAvailable)
                ? (session_type === 'MODERATED' ? (videoPlayed + analyseStart) : videoPlayed)
                : videoPopIn + analyseStart
              return (c.epoch_start <= pillTime && c.epoch_start + graphZoom * 2 >= pillTime);
            }

            const isSegmentInTime = (segment: any) => {
              const pillTime = (stimulus && videoAvailable)
                ? (session_type === 'MODERATED' ? videoPlayed + analyseStart : videoPlayed)
                : videoPopIn + analyseStart
              return (segment.start <= pillTime && segment.end > pillTime);
            }

            return (
              <div key={index} style={{ position: 'absolute', marginBottom: 45, }}>
                <div className={classes.section}>
                  {item?.moments && item?.moments.map((c: any, k: number) => {
                    if ((cliped && (cliped.start_clip <= c.epoch_start && c.epoch_start <= cliped.end_clip)) || !cliped)
                      return (
                        <Tooltip key={k} classes={tooltipClasses} title="Click for Key Moment details" placement="bottom" arrow>
                          <div
                            id={"key_" + c.epoch_start}
                            className={clsx(classes.pill, isPillInArea(c) && classes.pillInTime)}
                            onClick={(e) => handlePillClick(e, c, 'Key Moment')}
                            style={{
                              background: UtilService.refactorGraphColor(c.moment),
                              left: getPosition(c)
                            }}
                          />
                        </Tooltip>
                      )
                  })}
                </div>

                {(!isBlankRule ? (item.overall_index > 0 && item.pill !== 'Blank') : item.pill) && (
                  <Tooltip classes={tooltipClasses} title="Click for Segment details" placement="bottom" arrow>
                    <div
                      aria-describedby={'simple-popover'}
                      className={clsx(classes.box, isSegmentInTime(item) && classes.boxInTime)}
                      id={"segment_" + item.start}
                      style={{
                        left: (start - (session_type === 'ASYNC' ? cliped ? cliped.start_clip : 0 : graphStart)) * 15 / Math.pow(graphZoom, 2),
                        width: (end - start) * 15 / Math.pow(graphZoom, 2),
                        background: UtilService.refactorGraphColor(item.pill)
                      }}
                      onClick={(e) => handlePillClick(e, item, 'Segment')}
                    >
                      {/* {start + '*' + end} */}
                      {(end - start) / Math.pow(graphZoom, 2) > 5 && <img src={'/assets/icons/liveanalysis/graph-icon.svg'} alt={'icon'} style={{ marginRight: 5 }} />}
                      {(end - start) / Math.pow(graphZoom, 2) > 2 && (end > start) && item.overall_index > 0 && item.overall_index}
                    </div>
                  </Tooltip>
                )}
              </div>)
          })
        }
      </div>
      {
        overlay?.color &&
        <AnalyzeKeyMomentPopOut
          anchorEl={anchorEl}
          overlay={overlay}
          onZoom={onZoom}
          setAnchorEl={setAnchorEl}
        />
      }
    </div>
  );
}

export default PillSection;